const statuses = require('./statuses');
const buildAddedCharges = require('./buildAddedCharges');
const creditreasons = require('./creditreasons');
const removereasons = require('./removereasons');
const refundreasons = require('./refundreasons');
const { reductionReasons: reducereasons } = require('../commonordermethods/itemHelpers');
const addedchargedefinitions = require('./addedchargedefinitions');
const paymentErrors = require('../paymentMethods/paymentErrors');
const paymentAuthResults = require('../paymentMethods/paymentAuthResults');
const collectionMethods = require('../commonordermethods/collectionMethods');
const validateUpdateItemParams = require('./validateUpdateItemParams');

module.exports = Object.assign({
  buildAddedCharges,
  getStatuses(){
    return statuses;
  },
  getAddedChargeDefinitions(){
    return addedchargedefinitions;
  },
  getAddedChargeDefinition({ code, name }){
    if(typeof code !== 'undefined'){
      return addedchargedefinitions.find(c => c.code === code);
    }
    if(typeof name !== 'undefined'){
      return addedchargedefinitions.find(c => c.name === name);
    }
  },
  getCreditReasons(name){
    if(name){
      return creditreasons.find(
        r => r.name === name
      );
    }
    return creditreasons;
  },
  getRemoveReasons(name){
    if(name){
      return removereasons.find(
        r => r.name === name
      );
    }
    return removereasons;
  },
  getRefundReasons(name){
    if(name){
      return refundreasons.find(
        r => r.name === name
      );
    }
    return refundreasons;
  },
  getReduceReasons(name){
    if(name){
      return reducereasons.find(
        r => r.name === name
      );
    }
    return reducereasons;
  },
  validateUpdateItemParams,
  paymentErrors,
  getPaymentErrorName: code => paymentErrors[code],
  paymentAuthResults,
  getPaymentAuthResultName: code => paymentAuthResults[code]
}, collectionMethods);